import { ReactComponent as CheckIcon } from "components/Icons/check.svg";
import { useMessage } from "hooks/intl";
import { kebabCase } from "lodash";
import { Status, StatusType, StepDetails } from "types/stepper";
import { useStyles } from "./styles";

interface Props<T> {
  details: StepDetails<T>;
  onClick: () => void;
  index: number;
  "data-test-id"?: string;
}

export function Step<T>({
  details,
  onClick,
  index,
  "data-test-id": dataTestId,
}: Props<T>) {
  const { ACTIVE, VISITED, NOT_VISITED, ERROR } = Status;

  const { message } = useMessage();

  const classes = useStyles({
    hasError: !!details.hasError,
    errorStatus: details.status === ERROR,
  });

  const renderIcon = (status: StatusType, stepNumber: number) => {
    switch (status) {
      case ACTIVE:
        return <div className={classes.activeStepDot} />;
      case NOT_VISITED:
      case ERROR:
        return stepNumber;
      case VISITED:
        return <CheckIcon />;
    }
  };

  const getClassName = () => {
    switch (details.status) {
      case ACTIVE:
        return classes.active;
      case VISITED:
        return classes.visited;
      case NOT_VISITED:
        return classes.notVisited;
      case ERROR:
        return classes.error;
    }
  };
  const className = getClassName();

  return (
    <div
      className={classes.stepWrapper}
      onClick={onClick}
      data-test-id={dataTestId || kebabCase(details.label)}
    >
      <div
        className={`${classes.stepStatusIconWrapper} ${className} ${details.hasError ? classes.error : ""}`}
      >
        {renderIcon(details.status, index)}
      </div>
      <div>
        <span className={classes.stepLabel}>
          {message({ id: details.label })}
        </span>
        {details.description && (
          <span className={classes.stepDescription}>
            {message({ id: details.description })}
          </span>
        )}
      </div>
    </div>
  );
}
